import registerBlocks from "./blocks";
import registerFormats from "./formats";

import "./assets/styles/index.scss";

registerBlocks();
registerFormats();



// WEBPACK FOOTER //
// ./src/index.js